import script from "./PreFacturaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PreFacturaModal.vue?vue&type=script&setup=true&lang=js"

import "./PreFacturaModal.vue?vue&type=style&index=0&id=0cc829a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc829a2"]])

export default __exports__